import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import type { IAddress } from '../types';

import Address from './Address';
import './ui/Input.scss';

interface IAddressToggleProps {
  title?: string;
  address?: IAddress;
  showAddress?: boolean;
  showError?: boolean;
  propertyKey: string;
  toggleFunction: (propertyKey: string, visible: boolean) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  handleCheckboxChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sameAddressChecked?: boolean;
  disabled?: boolean;
  showCountrySelect?: boolean;
  hideName?: boolean;
  emailLabel?: string;
}

const AddressToggle: FC<IAddressToggleProps> = ({
  title,
  propertyKey,
  address,
  toggleFunction,
  showAddress = false,
  showError = false,
  disabled = false,
  onChange,
  sameAddressChecked,
  handleCheckboxChange,
  showCountrySelect,
  hideName,
  emailLabel
}) => {
  return (
    <div>
      <div className="styled-input">
        {title && (<label>{title}</label>)}
        <div className="buttons-wrap">
          <button
            className={classNames({ active: showAddress })}
            onClick={() => toggleFunction(propertyKey, true)}
          >
            Ja
          </button>
          <button
            className={classNames({ active: !showAddress })}
            onClick={() => toggleFunction(propertyKey, false)}
          >
            Nein
          </button>
        </div>
      </div>
      {showAddress && (
        <>
          <Address
            showError={showError}
            propertyKey={propertyKey}
            address={address}
            onChange={onChange}
            disabled={disabled}
            showCountrySelect={showCountrySelect}
            hideName={hideName}
            emailLabel={emailLabel}
          />
          {handleCheckboxChange && (
            <div className="styled-input-checkbox extra-mb">
              <input
                type="checkbox"
                id="sameAddress"
                checked={sameAddressChecked}
                onChange={handleCheckboxChange}
              />
              <label htmlFor="sameAddress">
                Abweichende Abholadresse für Rücksendeadresse verwenden
              </label>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AddressToggle;
